import { AgentLayerCounts } from "@/components/layout/AgentLayerCounts";
import { ROUTES } from "@/lib/routes";
import { cn } from "@/lib/utils";
import { Bot, Zap } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * Desktop Agent Layer band — fixed bottom chrome on md+.
 * Enter CTA is right-aligned with Bot icon + attention pulse (respects reduced-motion).
 */
export function AgentLayerRow({ className }: { className?: string }) {
	return (
		<div
			className={cn(
				/* Parent AppShell may own fixed positioning; default is full-width band */
				"header-band-agentic border-t border-yellow-500/30",
				className,
			)}
			data-agent-layer-band
		>
			<div className="container mx-auto flex items-center gap-3 px-3 py-3 sm:px-4 md:flex-nowrap">
				<div className="flex min-w-0 flex-1 items-center gap-2.5 overflow-hidden">
					<span className="flex size-8 shrink-0 items-center justify-center rounded-md border border-yellow-500/50 bg-yellow-400/15 text-yellow-400">
						<Zap className="size-4" />
					</span>
					<div className="min-w-0 shrink">
						<p className="truncate font-mono text-[11px] font-bold tracking-[0.12em] text-yellow-400 sm:text-xs">
							AGENT LAYER
						</p>
						<p className="truncate font-mono text-[10px] text-yellow-400/75 sm:text-[11px]">
							Autonomous layer for vault liquidations.
						</p>
					</div>
					<AgentLayerCounts className="hidden min-w-0 sm:ml-1 sm:flex" />
				</div>

				<nav
					className="ml-auto flex shrink-0 items-center justify-end"
					aria-label="Agent Layer"
				>
					<Link
						to={ROUTES.agents}
						className={cn(
							"agent-enter-cta group relative inline-flex h-9 items-center gap-2 overflow-hidden",
							"rounded-md border border-yellow-500/70 bg-[var(--agentic-yellow,#facc15)]",
							"px-3.5 font-mono text-[11px] font-bold text-black",
							"shadow-[0_0_0_1px_rgba(250,204,21,0.35),0_0_18px_rgba(250,204,21,0.35)]",
							"hover:bg-yellow-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-400",
						)}
					>
						<span
							className="agent-enter-cta__pulse pointer-events-none absolute inset-0 rounded-md"
							aria-hidden
						/>
						<Bot className="relative size-4 shrink-0" aria-hidden />
						<span className="relative">Enter Agent Layer</span>
					</Link>
				</nav>
			</div>
		</div>
	);
}
